import Typography from "@mui/material/Typography"

import Column from "../../../../../common/components/Column"
import CallRecordingPlayer from "../../../activity/CallRecordingPlayer"
import { getCallDispositionLabel } from "../../CallAttemptLogDialog"
import { PerformedBySubtitle } from "./PerformedByAttribution"

export default function CallRepresentation({ crmEvent }) {
  const recordingFile = crmEvent.recording_file
  const dispositionLabel = crmEvent.disposition
    ? getCallDispositionLabel(crmEvent.disposition)
    : null

  return (
    <Column gap={1.5}>
      <PerformedBySubtitle event={crmEvent} prefix="Attempted by" />
      {dispositionLabel ? (
        <Typography variant="body1">
          Outcome:{" "}
          <Typography component="span" fontWeight={600}>
            {dispositionLabel}
          </Typography>
        </Typography>
      ) : null}
      {crmEvent.notes ? (
        <Typography variant="body1" color="text.secondary">
          {crmEvent.notes}
        </Typography>
      ) : null}
      {recordingFile ? (
        <CallRecordingPlayer recordingFile={recordingFile} />
      ) : (
        <Typography variant="body1" color="text.secondary">
          No recording available
        </Typography>
      )}
    </Column>
  )
}
